import * as React from "react";
import { useState } from "react";

import { Field, withTypes } from "react-final-form";

import axios from "axios";

import {
  Button,
  CardActions,
  CircularProgress,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { Notification, useTranslate, useNotify } from "react-admin";

import { ENDPOINTS } from "../apiConstants";
import { getConfigPost } from "../getConfig";

const useStyles = makeStyles(() => ({
  main: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  form: {
    padding: "0 1em 1em 1em",
  },
  input: {
    marginTop: "1em",
  },
  actions: {
    padding: "0 1em 1em 1em",
  },
  result: {
    marginTop: "1em",
    padding: "1em",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    wordBreak: "break-all",
    maxWidth: "35em",
  },
}));

const renderInput = ({
  meta: { touched, error } = { touched: false, error: undefined },
  input: { ...inputProps },
  ...props
}) => (
  <TextField
    error={!!(touched && error)}
    helperText={touched && error}
    {...inputProps}
    {...props}
    fullWidth
  />
);

interface FormValues {
  email?: string;
  first_name?: string;
  last_name?: string;
}

const { Form } = withTypes<FormValues>();

const AdminEwalletRegistration = () => {
  const [loading, setLoading] = useState(false);
  const translate = useTranslate();
  const classes = useStyles();
  const notify = useNotify();
  const [result, setResult] = useState<{ success: boolean; user_id: number } | null>(null);

  const handleSubmit = (inputData: any) => {
    setLoading(true);
    setResult(null);
    const headers = getConfigPost();

    const data: any = { email: inputData.email };
    if (inputData.first_name) data.first_name = inputData.first_name;
    if (inputData.last_name) data.last_name = inputData.last_name;

    axios
      .post(ENDPOINTS.EWALLET_REGISTRATION, data, { headers })
      .then((res: any) => {
        setLoading(false);
        setResult(res.data);
        notify("Ewallet registration triggered successfully", "info", "", undefined, 10000);
      })
      .catch((error) => {
        setLoading(false);
        notify(
          error?.response?.data?.message || "Failed to trigger ewallet registration",
          "error",
          "",
          undefined,
          50000
        );
      });
  };

  const validate = (values: FormValues) => {
    const errors: FormValues = {};
    if (!values.email) {
      errors.email = translate("ra.validation.required");
    }
    return errors;
  };

  return (
    <Form
      onSubmit={handleSubmit}
      validate={validate}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} noValidate>
          <div className={classes.main}>
            <div className={classes.form}>
              <div className={classes.input}>
                <Field
                  autoFocus
                  name="email"
                  // @ts-ignore
                  component={renderInput}
                  label={translate("pos.email")}
                  disabled={loading}
                />
              </div>
              <div className={classes.input}>
                <Field
                  name="first_name"
                  // @ts-ignore
                  component={renderInput}
                  label="First Name (optional)"
                  disabled={loading}
                />
              </div>
              <div className={classes.input}>
                <Field
                  name="last_name"
                  // @ts-ignore
                  component={renderInput}
                  label="Last Name (optional)"
                  disabled={loading}
                />
              </div>
            </div>
            <Notification />
            <CardActions className={classes.actions}>
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disabled={loading}
                fullWidth
              >
                {loading ? <CircularProgress size={25} thickness={2} /> : "Trigger Ewallet Registration"}
              </Button>
            </CardActions>
            {result && (
              <div className={classes.result}>
                <strong>Success</strong> — user_id: {result.user_id}
              </div>
            )}
          </div>
        </form>
      )}
    />
  );
};

export default AdminEwalletRegistration;
